import NeoComponentController from './NeoComponentController';
import NeoComponentControllerPC from './NeoComponentController_pc';

angular
  .module( 'VSPApp' )
  .controller( 'NeoComponentController', NeoComponentController )
  .controller( 'NeoComponentController' + 'pc', NeoComponentControllerPC )
;
